/**
 * Utilities for Larvicide entries handling, normalisation, and display formatting.
 */

export const mapLarvicideType = (type) => {
  if (type === "BenzoylUreas") {
    return "Benzoilurea";
  }
  return type || null;
};

export const createEmptyLarvicideEntry = () => ({
  type: "",
  form: "",
  form_other: "",
  amount: "",
  unit: "",
});

export const normaliseLarvicideEntries = (item) => {
  if (!item) return [];

  let rawEntries = null;
  if (Array.isArray(item)) {
    rawEntries = item;
  } else if (item.larvicide_entries) {
    if (Array.isArray(item.larvicide_entries)) {
      rawEntries = item.larvicide_entries;
    } else if (typeof item.larvicide_entries === "string") {
      try {
        const parsed = JSON.parse(item.larvicide_entries);
        if (Array.isArray(parsed)) {
          rawEntries = parsed;
        }
      } catch (e) {
        rawEntries = null;
      }
    }
  }

  if (rawEntries && rawEntries.length > 0) {
    return rawEntries.map((entry) => ({
      type: entry?.type ?? null,
      form: entry?.form ?? null,
      form_other: entry?.form_other ?? null,
      amount:
        entry?.amount != null && entry?.amount !== ""
          ? String(entry.amount)
          : null,
      unit: entry?.unit ?? null,
    }));
  }

  // Legacy fallback when entries are empty or missing
  if (
    !Array.isArray(item) &&
    (item.type_larvicide ||
      item.total_larvicide != null ||
      item.total_larvicide_unit)
  ) {
    return [
      {
        type: item.type_larvicide ?? null,
        form: null,
        form_other: null,
        amount:
          item.total_larvicide != null && item.total_larvicide !== ""
            ? String(item.total_larvicide)
            : null,
        unit: item.total_larvicide_unit ?? null,
      },
    ];
  }

  return [];
};

export const formatLarvicideType = (entry) => {
  if (!entry?.type) return null;
  return mapLarvicideType(entry.type);
};

export const formatLarvicideForm = (entry) => {
  if (!entry?.form) return null;
  if (entry.form === "Lainnya") {
    return entry.form_other ? `Lainnya (${entry.form_other})` : "Lainnya";
  }
  return entry.form;
};

export const formatLarvicideAmount = (entry) => {
  if (entry?.amount == null || entry?.amount === "") return null;
  return String(entry.amount);
};

export const formatLarvicideUnit = (entry) => {
  if (!entry?.unit) return null;
  return entry.unit;
};

export const getLarvicideTypeDisplay = (item) => {
  const entries = normaliseLarvicideEntries(item);
  const values = entries
    .map(formatLarvicideType)
    .filter((v) => v !== null && v !== undefined && v !== "");
  return values.length > 0 ? values.join("; ") : "-";
};

export const getLarvicideFormDisplay = (item) => {
  const entries = normaliseLarvicideEntries(item);
  const values = entries
    .map(formatLarvicideForm)
    .filter((v) => v !== null && v !== undefined && v !== "");
  return values.length > 0 ? values.join("; ") : "-";
};

export const getLarvicideAmountDisplay = (item) => {
  const entries = normaliseLarvicideEntries(item);
  const values = entries
    .map(formatLarvicideAmount)
    .filter((v) => v !== null && v !== undefined && v !== "");
  return values.length > 0 ? values.join("; ") : "-";
};

export const getLarvicideUnitDisplay = (item) => {
  const entries = normaliseLarvicideEntries(item);
  const values = entries
    .map(formatLarvicideUnit)
    .filter((v) => v !== null && v !== undefined && v !== "");
  return values.length > 0 ? values.join("; ") : "-";
};

export const cleanLarvicideEntries = (entries) => {
  if (!Array.isArray(entries)) return [];
  return entries.map((entry) => ({
    type: entry?.type ? entry.type : null,
    form: entry?.form ? entry.form : null,
    form_other:
      entry?.form === "Lainnya" && entry?.form_other ? entry.form_other : null,
    amount:
      entry?.amount != null && entry?.amount !== ""
        ? String(entry.amount)
        : null,
    unit: entry?.unit ? entry.unit : null,
  }));
};
